<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">العنصر:</label>
          <div>{{ settingsKeys[key] }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">نوع القيمة:</label>
          <div>{{ typeChioces[valType] }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">القيمة:</label>
          <div class="english-input">{{ val }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: 'SettingsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    typeChioces: {
      type: Object,
      default: null,
    },
    settingsKeys: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      key: null,
      valType: null,
      val: null,
    }
  },
  created(){
    if(this.dataRow){
      this.key = this.dataRow.key;
      this.valType = this.dataRow.valType;
      this.val = this.dataRow.val;
    }
  }
}
</script>
